<template>
  <div class="panel-body">
    <div class="text-size-20">指定した年月の月末時点での在庫数をCSV形式でダウンロードできます</div>
    <div>※毎月の月初10営業日を目途に前月分のダウンロードが可能となります</div>
    <fieldset class="border bg-white col-md-4 mr-t-10" style="padding: 10px 10px 20px 10px;">
      <span class="m-r-sm m-b-none text-gray">年月</span>
      <div class="flexbox gap-20 mr-l-10">
        <select class="form-control w-200" v-model="month">
          <option value="">選択してください</option>
          <option v-for="item in months" :value="item" :key="item">{{ item }}</option>
        </select>
        <button type="button" class="btn btn-primary w-200" @click="openModalConfirmDownloadCsv()">ダウンロード</button>
      </div>
    </fieldset>
    <modal-confirm-download-csv
      v-if="isShowModalConfirm"
      :message="`月末在庫情報(CSV) をダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
      @close="closeModalConfirmDownloadCsv"
      @downloadCsv="handleDownloadCsv"
    />
  </div>
</template>

<script>
import WarehouseScService from '@/services/warehousescservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      isShowModalConfirm: false,
      month: '',
      months: []
    }
  },
  created () {
    this.getDataPullDown()
  },
  methods: {
    async getDataPullDown () {
      this.loader = this.$loading.show()
      await WarehouseScService.getMonths()
        .then((response) => {
          this.months = response.data.months
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    openModalConfirmDownloadCsv () {
      if (!this.month) {
        return false
      }
      this.isShowModalConfirm = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.isShowModalConfirm = false
    },
    async handleDownloadCsv () {
      this.closeModalConfirmDownloadCsv()
      if (!this.month) {
        return false
      }
      let logParams = {
        name: eventCode.warehouse_sc.inventory_tab.inventory_end_of_month.click_download_csv_btn,
        properties: {
          endOfMonth: this.month
        }
      }
      EventService.postTrackLog(logParams)
      let sellerId = this.$store.getters.getUser.sellerId
      let filename = `salmonLogiSc_inventoryEndOfMonth_${sellerId}_${this.month}.csv`
      let params = {
        endOfMonth: this.month
      }

      await WarehouseScService.downloadInventoryEndOfMonthCSV(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.inventory_tab.inventory_end_of_month.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.panel-body {
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/InventoryEndOfMonth.vue